
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ship-and-storage-near-me",
      function () {
        return require("private-next-pages/ship-and-storage-near-me/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ship-and-storage-near-me"])
      });
    }
  